import { SVGProps, Ref, forwardRef } from 'react';

export const BellCrossedFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.466 17.654C21.288 12.977 20.045 1 11.996 1c-2.12 0-3.766.83-5.046 2.14zM4.902 6.178C2.288 11.648 2.5 19.494 2.5 19.494h5.768c.466 1.969 1.588 3.5 3.731 3.5s3.266-1.531 3.732-3.5h2.49L21.727 23 23 21.728 2.273 1.004 1 2.276z"
            fill="currentColor"
        />
    </svg>
));
BellCrossedFilledSize24Glyph.displayName = 'BellCrossedFilledSize24Glyph';
